import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { StorageService } from '@fan-services/storage.service';
import { Observable } from 'rxjs';
import { accessTokenKey } from '../keys';
import { AnyObject } from '../types';

@Injectable()
export class HttpInterceptorService implements HttpInterceptor {
  constructor(private storage: StorageService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let avoid = false;
    avoid =
      avoid ||
      req.url.startsWith('https://maps.googleapis.com') ||
      req.url.includes('/v4/security-checks');
    const isTranslationsRequest = req.url.includes('/assets/i18n/');
    if (!avoid && !isTranslationsRequest) {
      const token = this.getToken();
      const headers: AnyObject = {};
      if (token && !req.headers.get('authorization')) {
        headers['Authorization'] = token;
      }
      req = req.clone({
        setHeaders: headers,
      });
    } else if (isTranslationsRequest) {
      // For translation requests, we don't want caching
      req = req.clone({
        setHeaders: {
          'Cache-Control': 'no-cache',
          Pragma: 'no-cache',
          Expires: '0',
        },
      });
    }
    return next.handle(req);
  }
  getToken() {
    return this.storage?.getAndParseItem(accessTokenKey);
  }
}
